// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5n-0";
export var eligibilityCardNotEligible = "_5n-1";